var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1607)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.96 1.5C12.64 1.5 13.3 1.71 13.86 2.1L20.82 6.9C21.82 7.59 22.42 8.75 22.42 10.02V17.75C22.42 20.37 20.4 22.51 17.92 22.51H6C3.52 22.51 1.5 20.37 1.5 17.75V10.02C1.5 8.76 2.1 7.59 3.1 6.9L10.06 2.1C10.63 1.71 11.29 1.5 11.96 1.5ZM11.96 0C11 0 10.04 0.29 9.21 0.86L2.25 5.66C0.84 6.62 0 8.26 0 10.01V17.74C0 21.2 2.69 24 6 24H17.93C21.24 24 23.93 21.2 23.93 17.74V10.01C23.93 8.26 23.09 6.62 21.68 5.66L14.72 0.86C13.88 0.29 12.92 0 11.96 0Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 15.38C14.4701 14.43 13.0001 12.78 11.4901 13.21C11.2601 13.27 11.0501 13.38 10.8501 13.5C10.0101 13.98 9.3001 14.68 8.6501 15.38C8.3001 15.75 7.9301 16.05 7.7201 16.54C7.4201 17.25 7.6901 18.13 8.2801 18.61C8.8701 19.09 9.6501 19.15 10.3701 18.97C11.0101 18.68 11.7201 18.53 12.4201 18.62C12.8601 18.67 13.2401 18.87 13.6601 18.97C14.2501 19.12 14.9201 19.13 15.4501 18.79C15.9201 18.49 16.3201 18 16.4201 17.44C16.4801 17.08 16.3901 16.72 16.2301 16.4C16.0101 15.98 15.6801 15.71 15.3701 15.37L15.3601 15.38Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71725 14.7333C8.43912 14.6315 8.90986 13.7376 8.76868 12.7369C8.62749 11.7361 7.92785 11.0073 7.20598 11.1092C6.48412 11.211 6.01338 12.1049 6.15456 13.1056C6.29575 14.1064 6.99539 14.8351 7.71725 14.7333Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1499 12.4601C10.9673 12.4601 11.6299 11.5602 11.6299 10.4501C11.6299 9.33997 10.9673 8.44006 10.1499 8.44006C9.33254 8.44006 8.66992 9.33997 8.66992 10.4501C8.66992 11.5602 9.33254 12.4601 10.1499 12.4601Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2747 10.5252C15.3268 9.41631 14.7071 8.48629 13.8907 8.44793C13.0742 8.40957 12.3701 9.27739 12.318 10.3863C12.2659 11.4951 12.8855 12.4251 13.702 12.4635C14.5185 12.5019 15.2226 11.634 15.2747 10.5252Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8318 13.2309C18.068 12.2767 17.6945 11.3633 16.9975 11.1908C16.3006 11.0183 15.5441 11.6521 15.308 12.6064C15.0718 13.5606 15.4454 14.474 16.1423 14.6465C16.8392 14.819 17.5957 14.1852 17.8318 13.2309Z",
    fill: "#767676"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_1607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.84b4e3ab881b559761f570ead6eddad1.svg";
export { ForwardRef as ReactComponent };